export enum CALLRECINTEGRATIONID {
    CALL_REC_INTEGRATION,
    SCOPE_ASSIGNMENT,
    COMMUNICATIONS_SETTINGS,
    DUBBER_COMMUNICATIONS_SETTINGS,
    TEST_INTEGRATION
}

export enum INTEGRATION_TYPES {
    DUBBER = 'Dubber',
    UNKNOWN = 'Unknown'
}

export enum INTEGRATION_TYPE_VALUES {
    UNKNOWN = -1,
    DUBBER = 0
}

export const DEFAULT_DUBBER_LOCATION_URL: string = 'api.dubber.net/sandbox'

export const INTEGRATION_TYPE_DEFAULT_VALUE: string = 'd7ae7ea9bf56ebdc:-53beea96:1556d0e14d3:-8000'

export const SERVER_UNKNOWN_VALUE: string = 'Unknown'

export const DEFAULT_INTEGRATION_TYPE: string = `0`
export const HASHED_PASSWORD_STRING: string = '*********'
